import React from 'react';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';

type ToastProps = {
    show: boolean;
    message: string;
};

const Toast: React.FC<ToastProps> = ({ show, message }) => {
    return (
        <AnimatePresence>
            {show && (
                <ToastWrap
                    role="status"
                    aria-live="polite"
                    initial={{ y: 40, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 40, opacity: 0 }}
                    transition={{ type: 'spring', duration: 0.35 }}
                >
                    {message}
                </ToastWrap>
            )}
        </AnimatePresence>
    );
};

export default Toast;

const ToastWrap = styled(motion.div)`
  position: fixed;
  right:0;
  left: 0;
  margin:0 auto;
  top:50%;
  transform: translate(0, -50%);
  height: fit-content;
  bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  z-index: 9999;
  max-width: min(90vw, 360px);
  padding: 10px;
  border-radius: 12px;
  background: rgba(49, 51, 56, 0.90);
  color: #fff;
  font-size: 12px;
  line-height: 1.45;
  text-align: center;
  white-space: pre-line;      
  pointer-events: none;      
`;
